import { z } from 'zod';
import { uuidSchema } from './common.js';
/** POST /orgs — signup flow; the creator becomes org_admin (BP-01 §2.4/§4). */
export const createOrgSchema = z.object({
    name: z.string().trim().min(2).max(120),
});
/**
 * PATCH /orgs/current — org_admin may change the name and the legal profile; branding is
 * super_admin-only (Master Spec §12). The legal profile (D-151 Batch 4, U1) carries the render
 * defaults for the contract templates: {{CustomerAddress}}, {{GoverningLaw}}, {{Jurisdiction}}.
 */
export const patchOrgSchema = z
    .object({
    name: z.string().trim().min(2).max(120).optional(),
    branding: z.record(z.unknown()).optional(),
    legalAddress: z.string().trim().max(400).nullable().optional(),
    governingLaw: z.string().trim().max(120).nullable().optional(),
    jurisdiction: z.string().trim().max(120).nullable().optional(),
})
    .strict();
export const orgSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    slug: z.string(),
    branding: z.record(z.unknown()),
    legalAddress: z.string().nullable(),
    governingLaw: z.string().nullable(),
    jurisdiction: z.string().nullable(),
    createdAt: z.string(),
});
//# sourceMappingURL=orgs.js.map